module.exports = __webpack_public_path__ + "static/media/ic-statistics.eb846945.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-statistics.svg
// module id = 673
// module chunks = 14